import { ButtonHTMLAttributes, forwardRef } from 'react'
import { TransitionStatus } from 'react-transition-group'

import { cn } from '@/lib/utils'

export type MenuButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  Partial<{
    state: TransitionStatus
  }>

const MenuButton = forwardRef<HTMLButtonElement, MenuButtonProps>(
  ({ state, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'fixed right-[4rem] top-spacing-sm z-hamb h-[4.4rem] w-[4.4rem] -translate-y-[1.5rem] translate-x-[0.8rem] md:right-margin md:top-spacing-lg md:-translate-y-[1.1rem]',
          className
        )}
        data-motion-hamb
        {...props}
      >
        <span className="sr-only">Menu</span>
        <span
          className="absolute left-1/2 top-1/2 h-[.2rem] w-[2.8rem] origin-right -translate-x-1/2 -translate-y-[.5rem]"
          data-motion-hamb-line-top
        >
          <span
            className={cn(
              'absolute left-0 top-0 h-full w-full origin-right bg-text-primary-dark',
              'transition-transform duration-300 ease-out-cubic',
              {
                'translate-x-[1.5rem] scale-x-0 duration-0': state === 'entering',
                'translate-x-0 scale-x-100': state === 'entered',
                'translate-x-[1.5rem] scale-x-0': state === 'exiting'
              }
            )}
          />
        </span>
        <span
          className="absolute left-1/2 top-1/2 h-[.2rem] w-[2.8rem] origin-right -translate-x-1/2 translate-y-[.3rem]"
          data-motion-hamb-line-bot
        >
          <span
            className={cn(
              'absolute left-0 top-0 h-full w-full origin-right bg-text-primary-dark',
              'transition-transform duration-300 ease-out-cubic',
              {
                'translate-x-[1.5rem] scale-x-0 duration-0': state === 'entering',
                'translate-x-0 scale-x-100 delay-75': state === 'entered',
                'translate-x-[1.5rem] scale-x-0 delay-75': state === 'exiting'
              }
            )}
          />
        </span>
      </button>
    )
  }
)

export default MenuButton
